<template>
  <div>
    
    <div class="content col-md-10">

      <b-navbar type="light" variant="light" sticky>
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>

          <!-- Navbar dropdowns -->
          <b-nav-item-dropdown text="Actions" left v-if="isAdmin()">
            <b-dropdown-item @click="doSubmit()">Enregistrer</b-dropdown-item>
            <b-dropdown-item @click="getHistory()">Afficher l'historique</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>

      <div class="card sticky-top border-dark" v-if="displayHistory">
        <div class="card-header">
          <h5 class="card-title">Historique des modifications</h5>
          <button type="button" class="close" data-dismiss="card" @click="hideHistory" aria-label="Fermer" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="card-body text-dark">
          <table class="table">
            <tr v-for="(h, index) in history" :key="h.id" style="font-size: small;">
              <td>{{history.length - index}}</td>
              <td><b>{{toDate(h.date)}}</b></td>
              <td><span :title="h.authorEmail">{{h.authorName}}</span></td>
              <td><ul v-html="h.htmlDiff"></ul></td>
            </tr>
          </table>
        </div>
      </div>
          <!-- <h5 v-if="titleField"><label-editable :resourcekey="formkey+'_title'" :text="titleField" /></h5> -->
          <!-- <h4 v-if="subTitleData"><label-editable :resourcekey="formkey+'_subtitle'" :text="subTitleData " /></h4> -->
          <h5>{{subTitleData()}}</h5>
          <!-- https://vueformulate.com/guide/ -->
          <!-- https://vueformulate.com/guide/forms/generating-forms/#schemas -->
          <FormulateForm
              id="formulate-form1"
              v-model="values"
              :schema="initSchema(this.schema)"
              @submit-raw="submitHandlerToScroll"
              @submit="onSubmit"
              class="card"
          />
          <div class="formulate-input col-md-6">{{REQUIRED_SYMBOL}} <label-editable resourcekey="form_required_fields_label" text="Champs obligatoires à renseigner" /></div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import common from '../../pages/common/pages.js'
import usermanager from '../../usermanager.js'
import ppeBusiness from 'ppe-business'

const REQUIRED_SYMBOL = "🎯" //"✨" //"👇"
export default {
    name: "ppe-form",
    props: {
      formkey: [String],

      entityName: String,

      title: {
        type: String,
        description: "Form title",
      },
      
      titleField: {
        type: String,
        description: "Field name to add to the title"
      },

      subTitle: {
        type: String,
        description: "Form subtitle"
      },

      schema : Array,

      endpoint : String,

      redirect : String,

      readonly : Boolean,
      
    },
    data() { 
            return { 
              REQUIRED_SYMBOL:REQUIRED_SYMBOL,
              values : {},
              displayHistory:false,
              history: []
            } },

    mounted() {
      // Each endpoint should return 
      // res.status(200).json({ status:200, entity:record } )
      // and optional other entities : operation, user, that will not be modified neither saved
      this.$http.get(this.endpoint)
        .then(response => {
          console.log(this.endpoint + ":DATA", response.data)
          this.values = response.data.entity
          // append other objects such as user, operation, ... returned by server
          for(let other in response.data) {
            if(other !== 'entity') this[other] = response.data[other];
          }
          this.$emit('dataLoaded', response.data)
          window.scrollTo(0,0);
          } )
        .catch(err => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          console.error("ERROR", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
        })
    },

    methods : {
      ...common.methods,
      toDate : ppeBusiness.toDateTime,

      initSchema(schema) {
          if(!schema) return []

          
          let ret = this.parseSchema(schema)

        // Only add a button if at the root and add the actual author
        if(!this.readonly) {
          ret.push({type: 'submit',class:'col-md-3', id:"formulate-submit", label: 'Enregistrer', })
        }
        return ret;
      },
      subTitleData() {
        
        let titleField = this.titleField.replace(/{/g, "{{").replace(/}/g, "}}")
        let subTitle = ppeBusiness.replaceFieldsInString(titleField, {...this.values, ...this})

        console.log("subTitleData", subTitle)
        return subTitle
      },

      parseSchema(schema) {
        if(!schema) return []
        let ret = []
        let index = 0
        for(let item of schema) {
          if(item && item.body) {
            ret.push(this.createCard(item, index++))
          } else if(item) {
            let createdItem = this.createItem(item, index++)
            //console.log('parseSchema()', createdItem)
            ret.push(createdItem)
          }
        }
        
        return ret
      },

      doSubmit() {
        //this.$el.querySelector("#formulate-form1").submit()
        this.$el.querySelector("#formulate-submit").click()
      },

      async onSubmit(formData) {

        let postData = formData
        console.log("Form.vue:onSubmit():postData", postData)
        
        try {
            console.log("this.$usermanager.getAuthor().name", this.$usermanager.getAuthor())
            var author = this.$usermanager.getAuthor()
            if(author) postData._author = author._id
            
            postData._URL_PAGE = this.$route.fullPath //this.urlBack().path

            let response = await this.$http.post(this.endpoint, postData);
            console.log("Form.vue:onSubmit():response.data", this.endpoint, response.data)

            if(response.data.token && !usermanager.isAdmin()) { // if a login token exists, then log the user in
                if(this.$usermanager.logUserIn(response.data.token)) {
                  swal({title:"Enregistrement", text:"Information enregistrées", icon:"success", timer:2000,buttons: false,} );
                } else {
                  swal("Enregistrement", "Impossible de s'identifier", "error");
                }
            } else {
              swal({title:"Enregistrement", text:"Information enregistrées", icon:"success", timer:1500,buttons: false} );
            }
            if(this.$route.query.redirectUrl || this.redirect) {
              // Manage a redirect like '/home/default/:id' to be replaced with '/home/default/123456789'
              console.log("Form.vue:onSubmit():redirect", this.redirect)
              console.log("Form.vue:onSubmit():response.data.entity", response.data.entity)
              
              let redirectUrl = this.$route.query.redirectUrl || this.redirect
              if( response.data.entity) {
                redirectUrl = redirectUrl.replace(":id", response.data.entity.id)
                redirectUrl = redirectUrl.replace(":operationid", response.data.entity.operationId) 
              }
              let event = {redirectUrl:redirectUrl}

              this.$emit('submitDone', response.data, event)

              this.$router.replace(event.redirectUrl);
            }
        } catch (err) {
            console.error("Form.vue:onSubmit(): "+this.endpoint, err.response?err.response.data:err);
            swal("Erreur", (err.response.data?JSON.stringify(err.response.data):JSON.stringify(err.message)), "error");
            
        }

      },

      getHistory() {
        if(this.displayHistory) {this.displayHistory=false; return;}
        let url = `/admin/gethistory?entityid=${this.values.id}&entityname=${this.entityName}`
        this.$http.get(url)
        .then(response => {
          console.log(url + ":DATA", response.data)
          //this.values = response.data.entity
          this.displayHistory = true
          this.history = response.data.history
          
          } )
        .catch(err => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          console.error("ERROR", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
        })
      },

      hideHistory() {
        this.displayHistory = false
      },

      createCard(item, index) {
        let item_name = (""+item.name).replace('.', '_')
        item_name = this.$router.history.current.name + "_" + item_name
        return {component:"div", class:"card col-md-12 "+ (item.class || ""), children:[ { component:"div", class:"card-header " + (item.class || ""), children:[ 
                 {component:"h4", class : "card-title " + (item.class || ""),
                 children : [{component:'label-editable', text:item.card, resourcekey:item_name+"_card_"+index}]
                 }]},{component : "div", class:"card-body", children:[{ 
                    component: 'div', class: 'row', children : this.parseSchema(item.body)
                }]}] 
        }
      },

      isTextInput(item) {
        return ['textarea','text','number', 'email', 'password', 'select'].indexOf(item.type) >= 0  
      },

      getItemSize(item) {
        return (item.size==='large'?'col-md-12' : (item.size=='small'?'col-md-3':'col-md-6')) + ' ' + (item.class||'')
      },

      createItem(item, index) {
        if(this.readonly) {
          item.readonly=true
        }
        // Create a item_name to have unique resourcekey for label-editable
        let item_name = (""+item.name).replace('.', '_')
        item_name = this.$router.history.current.name + "_" + item_name

        // Manage the edit mode to insert editable items instead of actual controls
        if(this.$features.labelEditMode)  {
          
          let newItem = {
            component:'div', class:this.getItemSize(item), children:[ 

            ]
          }

          if(item.label)
            newItem.children.push({component:'label-editable', resourcekey:item_name+"_label", text:item.label})
          if(item.placeholder)  
            newItem.children.push({component:'div', class:'row border m-2 p-2', children:[{component:'label-editable', resourcekey:item_name+"_placeholder", text:item.placeholder}]})
          else if(this.isTextInput(item)) {
            newItem.children.push({component:'div', class:'row border m-2 p-2', children:[{component:'span', children:"."}]})
          }
          if(typeof item.children === "string") {
            newItem.component = item.component
            newItem.children.push({component:'label-editable', resourcekey:item_name+"_children_"+index, text:item.children})
          }

          if(item.help)
            newItem.children.push({component:'label-editable', resourcekey:item_name+"_help", text:item.help})

          if(item.options) {
            newItem.children.push( item )
          }
  
          if( newItem.children.length>0)
            return newItem
          return item
          
        } else {
            if(item.label)                        item.label = this.$t(item_name+"_label", item.label)
            if(item.placeholder)                  item.placeholder = this.$t(item_name+"_placeholder", item.placeholder)
            if(typeof item.children === "string") item.children = this.$t(item_name+"_children_"+index, item.children)
          }
        return {
                ...item,

                class: this.getItemSize(item), 
                
                type: item.type || 'text',

                label: (item.validation && item.validation.indexOf('required')>=0 ? REQUIRED_SYMBOL+" ":"") + (item.label||''),
                validationName: item.validationName || `'${item.label}'`,
                placeholder: item.placeholder || (item.label + (item.validation && item.validation.indexOf('required')>=0? " obligatoire" : "")),

                }
      },

      back() {
        let redirectUrl = this.$route.query.redirectUrl 
        if(redirectUrl)
          this.$router.push(redirectUrl);
        else
          this.$router.back();
      },

      hasBack() {
        return !!this.$route.query.redirectUrl 
      },

      // inspired : https://github.com/wearebraid/vue-formulate/issues/290
      submitHandlerToScroll(submitResult) {
        submitResult.hasValidationErrors().then((hasErrors) => {
          if (hasErrors) {
            this.scrollToError(submitResult.form.$el);
          } else {
            submitResult.values().then((data) => {
              // do nothind, then the submit() will occur
            });
          }
        });
      },

      scrollToError($formEl) {
        const errorWrapperEl =  $formEl.querySelector('[data-has-errors="true"]');
        const errorWrapperInput = errorWrapperEl && errorWrapperEl.querySelector('input,select,textarea');
        if (errorWrapperInput) {
          errorWrapperInput.focus();
          errorWrapperInput.scrollIntoView({block:'center'});
        }
      }, 


    }
}

</script>